var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStackedBarChartHorizontalGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 2.5L1.66602 17.5",
    stroke: "#2A2B28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0176 4.66665L13.0176 3.33333C13.0176 2.875 12.6426 2.5 12.1842 2.5L5.00092 2.5C4.54258 2.5 4.16758 2.875 4.16758 3.33333L4.16758 4.66665C4.16758 5.12498 4.54258 5.49998 5.00092 5.49998L12.1842 5.49998C12.6426 5.49998 13.0176 5.12498 13.0176 4.66665Z",
    stroke: "#2A2B28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6758 10.6666L15.6758 9.33333C15.6758 8.875 15.3008 8.5 14.8424 8.5L5.00078 8.5C4.54245 8.5 4.16745 8.875 4.16745 9.33333L4.16745 10.6666C4.16745 11.125 4.54245 11.5 5.00078 11.5L14.8424 11.5C15.3008 11.5 15.6758 11.125 15.6758 10.6666Z",
    stroke: "#2A2B28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 16.6666L18.334 15.3333C18.334 14.875 17.959 14.5 17.5007 14.5L5.00065 14.5C4.54232 14.5 4.16732 14.875 4.16732 15.3333L4.16732 16.6666C4.16732 17.125 4.54232 17.5 5.00065 17.5L17.5007 17.5C17.959 17.5 18.334 17.125 18.334 16.6666Z",
    stroke: "#2A2B28",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBarChartHorizontalGrey);
export default __webpack_public_path__ + "static/media/stacked-bar-chart-horizontal-grey.c68b9fc956786c68aacc09bcf010d610.svg";
export { ForwardRef as ReactComponent };